<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{
              $t('addDomiciliationBancaire.domBancaireReglement.popUpCreateSpecialisation.title')
            }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <div class="columns is-multiline">
        <b-field :label="$t(
          'addDomiciliationBancaire.domBancaireReglement.popUpCreateSpecialisation.sens'
          )" class="obligatoire column is-5 mgb-0">
          <b-select v-model="specialisation.sens"
                    expanded
                    @input="specialisation.modeReglementId = null">
            <option :value="constantes.SENS_VENTE">
              {{ $t('general.sens.vente') }}
            </option>
            <option :value="constantes.SENS_ACHAT">
              {{ $t('general.sens.achat') }}
            </option>
          </b-select>
        </b-field>
        <b-field :label="$t( specialisation.sens === constantes.SENS_VENTE ?
          'addDomiciliationBancaire.domBancaireReglement.popUpCreateSpecialisation.modeReglement'
          : 'addDomiciliationBancaire.domBancaireReglement.popUpCreateSpecialisation.modePaiement'
          )" class="obligatoire column is-7 mgb-0">
          <b-select v-model="specialisation.modeReglementId"
                    expanded>
            <option v-for="mode in modesReglement"
                    :key="mode.id"
                    :value="mode.id">
              {{ mode.libelle }}
            </option>
          </b-select>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="addSpecialisation()">
              {{ $t('general.button.next') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import genererSpecialisation from '@/services/parametrage/generation/genererSpecialisation';
import { SENS_VENTE, SENS_ACHAT } from '@/configuration/devisConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageSuccess from '@/services/general/messageSucces';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    domiciliationBancaire: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      specialisation: genererSpecialisation(),
      messages: [],
      error: false,
      constantes: {
        SENS_VENTE,
        SENS_ACHAT,
      },
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    modesReglement() {
      if (this.specialisation.sens === SENS_VENTE) {
        return this.parametre(PARAMETRES_KEYS.modeReglement);
      }
      return this.parametre(PARAMETRES_KEYS.modeReglement).filter((mode) => {
        return mode.actionAchat !== AUCUN;
      });
    },
  },
  methods: {
    addSpecialisation() {
      this.error = false;
      this.messages = [];
      if (!this.specialisation.modeReglementId) {
        this.messages.push({
          message: this.specialisation.sens === SENS_VENTE
            ? 'addDomiciliationBancaire.error.addSpecialisation.modeReglement'
            : 'addDomiciliationBancaire.error.addSpecialisation.modePaiement',
        });
        this.error = true;
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      this.specialisation.libelleEcriture = this.specialisation.sens === SENS_VENTE
        ? this.domiciliationBancaire.libelleEcritureReglement
        : this.domiciliationBancaire.libelleEcriturePaiement;
      this.specialisation.libelleLigneEcritureTiers = this.specialisation.sens === SENS_VENTE
        ? this.domiciliationBancaire.libelleLigneEcritureReglementTiers
        : this.domiciliationBancaire.libelleLigneEcriturePaiementTiers;
      this.specialisation.libelleLigneEcritureBanque = this.specialisation.sens === SENS_VENTE
        ? this.domiciliationBancaire.libelleLigneEcritureReglementBanque
        : this.domiciliationBancaire.libelleLigneEcriturePaiementBanque;
      this.specialisation.libelleReferenceBanque = this.specialisation.sens === SENS_VENTE
        ? this.domiciliationBancaire.libelleReferenceReglementBanque
        : this.domiciliationBancaire.libelleReferencePaiementBanque;
      this.specialisation.libelleReferenceTiers = this.specialisation.sens === SENS_VENTE
        ? this.domiciliationBancaire.libelleReferenceReglementTiers
        : this.domiciliationBancaire.libelleReferencePaiementTiers;
      this.$emit('addSpecialisation', this.specialisation);
      messageSuccess(this.$i18n.t('addDomiciliationBancaire.success.addDomBancaireReglement'));
      loadingComponent.close();
    },
  },
};
</script>
